export type DateString = string;

export const END_DATE_PRESET_IDS = ["Today", "Yesterday"] as const;

export type EndDatePresetId = (typeof END_DATE_PRESET_IDS)[number];

/** True when the user has picked a start date and still needs an end date. */
export function isPickingEndDate(
  mode: "single" | "range",
  dateRange: [DateString?, DateString?],
): boolean {
  return mode === "range" && Boolean(dateRange[0] && !dateRange[1]);
}

/** Build a sorted range using an existing start and a chosen end date. */
export function completeRangeWithEnd(
  startDate: DateString,
  endDate: DateString,
): [DateString, DateString] {
  if (endDate < startDate) {
    return [endDate, startDate];
  }
  return [startDate, endDate];
}

export function isEndDatePreset(label: string): label is EndDatePresetId {
  return END_DATE_PRESET_IDS.includes(label as EndDatePresetId);
}

/** Preset button label when completing an in-progress range. */
export function getEndDatePresetLabel(label: string): string {
  if (label === "Today") return "Through today";
  if (label === "Yesterday") return "Through yesterday";
  return label;
}
